"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _a;

var React = require("react");

var hs_web_style_guide_1 = require("@headspace/hs-web-style-guide");

var StepProgress_1 = require("../StepProgress/StepProgress");

exports.Provider = (_a = React.createContext({
  nextCard: function nextCard() {},
  previousCard: function previousCard() {}
}), _a.Provider), exports.Consumer = _a.Consumer;
var cardFlowStyle = hs_web_style_guide_1.css({
  height: '100%',
  position: 'relative'
});
var stepStyles = hs_web_style_guide_1.css({
  position: 'absolute',
  width: '100%',
  top: '0'
});

var CardFlow =
/** @class */
function (_super) {
  __extends(CardFlow, _super);

  function CardFlow(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      currentStep: 1,
      steps: 1
    };
    _this.nextCard = _this.nextCard.bind(_this);
    _this.previousCard = _this.previousCard.bind(_this);
    return _this;
  }

  CardFlow.prototype.componentWillMount = function () {
    this.setState({
      steps: React.Children.count(this.props.children)
    });
  };

  CardFlow.prototype.nextCard = function () {
    var currentStep = this.state.currentStep;
    var nextStep = currentStep === this.state.steps ? currentStep : currentStep + 1;
    this.setState({
      currentStep: nextStep
    });
  };

  CardFlow.prototype.previousCard = function () {
    var currentStep = this.state.currentStep;
    var prevStep = currentStep === 1 ? 1 : currentStep - 1;
    this.setState({
      currentStep: prevStep
    });
  };

  CardFlow.prototype.render = function () {
    var children = this.props.children;
    var _a = this.state,
        steps = _a.steps,
        currentStep = _a.currentStep;
    return (// provide functions to be used by child elements and components to move to next or previous cards
      React.createElement(exports.Provider, {
        value: {
          nextCard: this.nextCard,
          previousCard: this.previousCard
        }
      }, React.createElement("div", __assign({
        className: "card-flow"
      }, cardFlowStyle), React.createElement("div", __assign({}, stepStyles), React.createElement(StepProgress_1.StepProgress, {
        steps: steps,
        currentStep: currentStep,
        barColor: this.props.progressColor
      })), React.Children.toArray(children).filter(function (child, i) {
        return i + 1 === currentStep;
      })))
    );
  };

  return CardFlow;
}(React.Component);

exports.CardFlow = CardFlow;